/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_Search_What_PlaceholderInputs */

const en_events_search_what_placeholder = /** @type {(inputs: Events_Search_What_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yoga, running, a name…`)
};

const pl_events_search_what_placeholder = /** @type {(inputs: Events_Search_What_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joga, bieganie, nazwa…`)
};

/**
* | output |
* | --- |
* | "Yoga, running, a name…" |
*
* @param {Events_Search_What_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const events_search_what_placeholder = /** @type {((inputs?: Events_Search_What_PlaceholderInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Search_What_PlaceholderInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_events_search_what_placeholder(inputs)
	return en_events_search_what_placeholder(inputs)
});